/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DailyAvailabilitiesDurationsList } from '../../models/daily-availabilities-durations-list';

export interface GetStationDailyAvailabilitiesDurations$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The start date time of station daily availabilities to filter
 */
  start: string;

/**
 * The end date time (excluded) of station daily availabilities to filter
 */
  end: string;
}

export function getStationDailyAvailabilitiesDurations(http: HttpClient, rootUrl: string, params: GetStationDailyAvailabilitiesDurations$Params, context?: HttpContext): Observable<StrictHttpResponse<DailyAvailabilitiesDurationsList>> {
  const rb = new RequestBuilder(rootUrl, getStationDailyAvailabilitiesDurations.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('start', params.start, {});
    rb.query('end', params.end, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DailyAvailabilitiesDurationsList>;
    })
  );
}

getStationDailyAvailabilitiesDurations.PATH = '/custom/stations/{uid}/availabilities/durations';
